module.exports = __webpack_public_path__ + "static/media/man-working@2x.e81c5c87.png";